import { ChannelLastMessage } from 'services/chat';
import { Message } from './message';
import { ChannelType, ChatUser } from './types';

export class Channel {
	id: string;
	name: string;
	image: string;
	members: string[];
	channelType: ChannelType;
	lastMessageId: string;
	lastMessageTimestamp: number;
	notificationCount: number;
	lastMessage?: ChannelLastMessage;

	constructor(
		id: string,
		name: string,
		image: string,
		members: string[],
		channelType: ChannelType,
		lastMessageId: string,
		lastMessageTimestamp: number,
		notificationCount: number
	) {
		this.id = id;
		this.name = name;
		this.image = image;
		this.members = members;
		this.channelType = channelType;
		this.lastMessageId = lastMessageId;
		this.lastMessageTimestamp = lastMessageTimestamp;
		this.notificationCount = notificationCount;
	}

	isDirectMessaging(): boolean {
		return (
			this.channelType === ChannelType.DirectMessaging ||
			this.channelType === ChannelType.DirectReadonly ||
			this.channelType === ChannelType.FarmerSupportMessaging ||
			this.channelType === ChannelType.SpecialistSupportMessaging
		);
	}

	setDataFromUser(user: ChatUser): Channel {
		this.name = user.name + ' ' + user.surname;
		this.image = user.avatar;
		return this;
	}

	updateLastMessageTimestamp(timestamp: number): Channel {
		this.lastMessageTimestamp = timestamp;
		return this;
	}

	updateLastMessageId(messageId: string): Channel {
		this.lastMessageId = messageId;
		return this;
	}

	updateNotificationCount(count: number): Channel {
		this.notificationCount = count;
		return this;
	}

	setLastMessage(message: Message): Channel {
		this.lastMessageId = message.id;
		this.lastMessageTimestamp = message.createDate.getTime() / 1000;
		return this;
	}

	setServiceLastMessage(message: ChannelLastMessage | undefined): Channel {
		if (!message) return this;

		this.lastMessageId = message.id;
		this.lastMessageTimestamp = message.createdAt;
		this.lastMessage = message;
		return this;
	}

	getLastMessageContent(): string | null {
		if (!this.lastMessage?.content) return null;

		try {
			const contentArray = JSON.parse(this.lastMessage.content);
			if (Array.isArray(contentArray) && contentArray.length > 0) {
				const firstContent = contentArray[0];
				if (firstContent.type === 'RichText' && firstContent.content) {
					// Simple HTML stripping for plain text
					return firstContent.content.replace(/<[^>]*>?/gm, '').trim();
				}
				return firstContent.content || null;
			}
			return null;
		} catch (e) {
			// If JSON parsing fails, return the original content
			return this.lastMessage.content;
		}
	}
}
